import { RouteObject } from "react-router-dom";

export const hooksRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Hooks" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { HooksOverviewPage } = await import("./HooksOverviewPage");
          return { Component: HooksOverviewPage };
        },
      },
    ],
  },
];
